// The Intercom saved replies an e-mail task drafts from (intercom_macros).
export const EMAIL_TEMPLATES = [
  'Envoi de la plaquette',
  'Relance de proposition',
  'Récapitulatif mensuel',
  'Prise de rendez-vous',
  'Devis',
];
